
//TODO(Celso): Pensar se queremos isso genérico ou específico para um tipo de arquivo.
//TODO(Celso): Pensar nome melhor.
export const onFileRead = (event, onSave, type) => {
	let file = null;

	if (type === 'drag') {
		if (event.dataTransfer.files.length === 0) return;
		file = event.dataTransfer.files[0];
	} else {
		if (event.target.files.length === 0) return;
		file = event.target.files[0];
	}

	let reader = new FileReader();

	reader.onloadend = () => {
		let base64result = reader.result.split(',')[1];
		onSave(base64result);
	};

	reader.readAsDataURL(file);
};
